import Map from './Map';
import Header from './Header';

function App() {
  return (
    <div className="ccl-style ccl-color_generic">
      <main>
        <Header/>
        <Map/> 
      </main>
    </div>
  );
}

export default App;
